module.exports = __webpack_public_path__ + "static/media/powered_by.daa51a7f.svg";